import {
  formatNormalNumber,
  createKpiTileItem,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { marketsSupported } = data;

    return createKpiTileItem(
      'Markets Supported',
      formatNormalNumber(marketsSupported),
      null
    );
  },
};
